import { render, staticRenderFns } from "./PersistentDialog.vue?vue&type=template&id=598428ea&"
import script from "./PersistentDialog.vue?vue&type=script&lang=ts&"
export * from "./PersistentDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PersistentDialog.vue?vue&type=style&index=0&id=598428ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports